import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { CHANGE, FOCUS } from "redux-form/lib/actionTypes";
import $ from "jquery";

import Container from "./Container";
import Clock from "../Clock";
import Drawer from "../CartDrawer";
import ErrorBoundary from "../../component/ErrorBoundary";
import { initStore } from "../../store";
import { injectReducer, injectReduxFormReducerPlugin } from "../../store/reducers";
import cartReducer, { cartFormReducer, initialize as initCart } from "../../store/modules/cart";
import clockReducer from "../../store/modules/clock";
import Loader from "../../component/Loader";
import i18n from "../../lib/i18n";

if (__DEV__) {
  // eslint-disable-next-line no-console
  console.log(process.env);
}

const store = initStore();

injectReducer(store, { key: "clock", reducer: clockReducer });
injectReducer(store, { key: "cart", reducer: cartReducer });

injectReduxFormReducerPlugin(store, { form: "cart", reducer: cartFormReducer });

const productFormReducer = (state, action) => {
  const hasChanged = state && state.values && (action.type === FOCUS || action.type === CHANGE);

  if (hasChanged) {
    delete state.submitSucceeded;
  }
  if (hasChanged && action.meta.field === "customPrice") {
    state.values.productCollectionMemberId = 0;
  }

  return state;
};

injectReduxFormReducerPlugin(store, {
  form: "product",
  reducer: productFormReducer
});

const render = (cmp, mnt) => {
  ReactDOM.hydrate(
    <Provider store={store}>
      <ConnectedRouter history={store.history}>
        <ErrorBoundary>{cmp}</ErrorBoundary>
      </ConnectedRouter>
    </Provider>,
    mnt
  );
};

const MOUNT_NODE = document.getElementById("Cart__Dummy");

if (MOUNT_NODE) {
  const unsubscribe = store.subscribe(() => {
    const state = store.getState();
    if (state.cart.get("hasInitialized", false)) {
      render(<Container />, document.getElementById("cart"));
      unsubscribe();
    } else {
      render(
        <div className="Loader__wrapper d-flex flex-column flex-1 flex-no-shrink justify-content-center align-items-center">
          <Loader message={i18n.t("Please wait, delivery options are being checked")} messagePosition="bottom" />
        </div>,
        MOUNT_NODE
      );
    }
  });
}

const MOUNT_NODE_DRAWER = document.getElementById("CartDrawer__Toggle");
if (MOUNT_NODE_DRAWER) {
  store.dispatch(initCart());
  const unsubscribe = store.subscribe(() => {
    const state = store.getState();
    if (state.cart.get("hasInitialized", false)) {
      render(<Drawer />, MOUNT_NODE_DRAWER);
      unsubscribe();
    }
  });
}

const MOUNT_NODE_CLOCK = document.getElementById("CountdownClock");
if (MOUNT_NODE_CLOCK) {
  setTimeout(() => {
    render(
      <Clock postToPage activeClassName="category__filter" id={$(MOUNT_NODE_CLOCK).data("id")} />,
      MOUNT_NODE_CLOCK
    );
  }, 1);
}

if (module.hot) {
  if (MOUNT_NODE) {
    module.hot.accept("./Container", () => {
      // eslint-disable-next-line global-require
      const Hmz = require("./Container").default;
      render(<Hmz />, MOUNT_NODE);
    });
  }
  if (MOUNT_NODE_DRAWER) {
    module.hot.accept("../CartDrawer", () => {
      // eslint-disable-next-line global-require
      const Hmz = require("../CartDrawer").default;
      render(<Hmz />, MOUNT_NODE_DRAWER);
    });
  }
  if (MOUNT_NODE_CLOCK) {
    module.hot.accept("../Clock", () => {
      // eslint-disable-next-line global-require
      const Hmz = require("../Clock").default;
      render(<Hmz id={$(MOUNT_NODE_CLOCK).data("id")} />, MOUNT_NODE_CLOCK);
    });
  }
}

// registerServiceWorker();
